import { createAction, createSlice } from "@reduxjs/toolkit";

const getTotalEnrollInstructorSlice = createSlice({
  name: "getTotalEnrollInstructor",
  initialState: { data: null, processing: false },
  reducers: {
    pending(state, action) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.data = action.payload.data;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = getTotalEnrollInstructorSlice;
const getTotalEnrollInstructorAction = createAction(name);

export {
  getTotalEnrollInstructorAction,
  actions as getTotalEnrollInstructorActions,
  reducer as getTotalEnrollInstructorReducer,
};
